import { render, staticRenderFns } from "./GerenciadorResultadosAction.vue?vue&type=template&id=fa44b7c0&scoped=true&"
import script from "./GerenciadorResultadosAction.vue?vue&type=script&lang=js&"
export * from "./GerenciadorResultadosAction.vue?vue&type=script&lang=js&"
import style0 from "./GerenciadorResultadosAction.vue?vue&type=style&index=0&id=fa44b7c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa44b7c0",
  null
  
)

export default component.exports